import { RootState } from '../../types';

export const openById = (state: RootState, id: string) =>
  state.app.modals.show.includes(id);
export const openedModals = (state: RootState) => state.app.modals.show;
